import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about-page">

      <h1 className="about-title">About Masters Degree & PG College</h1>

      {/* BASIC INFO */}
      <section className="about-section">
        <h2>College Information</h2>
        <p><b>Year of Establishment:</b> 2005</p>
        <p><b>College Type:</b> Private Co-Education Institution</p>
        <p><b>Approvals:</b> UGC Approved | AICTE Recognized |  Affiliated to Osmania University</p>
      </section>

      {/* MISSION & VISION */}
      <section className="about-section">
        <h2>Our Mission</h2>
        <p>
          To provide quality education, develop professional skills,
          and create socially responsible citizens with strong moral values.
        </p>

        <h2>Our Vision</h2>
        <p>
          To become a center of excellence in higher education by promoting
          innovation, research, and student empowerment.
        </p>
      </section>

      {/* CAMPUS PHOTOS */}
      <section className="about-section">
        <h2>Campus Gallery</h2>
        <div className="gallery">
          <img src="/images/clg-bg.png" alt="Campus" />
          <img src="/images/bgimage-bg.png" alt="Classroom" />
          <img src="/images/Library.png" alt="Library" />
          <img src="/images/facilities-page.png" alt="Labs" />
        </div>
      </section>

      {/* STUDENT DEVELOPMENT */}
      <section className="about-section">
        <h2>Student Development</h2>
        <ul className="development-list">
          <li>📚 Academic Clubs & Technical Societies</li>
          <li>🎭 Cultural Activities & Annual Fest</li>
          <li>🏏 Sports & Inter-College Competitions</li>
          <li>🌱 NSS & Social Service Programs</li>
          <li>💼 Workshops, Seminars & Guest Lectures</li>
          <li>🚀 Career Guidance & Placement Training</li>
        </ul>
      </section>

    </div>
  );
}

export default About;

